<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <!-- Page Loader -->
    <div class="col-lg-10 align-self-center">
      <h2>{{ $t("navigations.visit predictiondashboard") }}</h2>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-lg-12 pr-1">
    <div class="card p-3 mb-2 ">

  <div class="d-flex justify-content-between border border-bottom-0 bg-white p-2">
    <h4>Site Risk Assessment</h4>
    <div>
      <button class="btn btn-outline-danger btn-sm me-2 px-3" @click="HighRiskSites()">High Risk</button>
       <button class="btn btn-outline-primary btn-sm px-3" @click="showAllSites()">All Sites</button>
    </div>
  </div>

  <div class="table-responsive">

    <table class="table table-hover table-bordered align-middle">

      <thead>
        <tr>
          <th class="text-center extra-bold">Site Code</th>
          <th class="text-center extra-bold">WRI Score</th>
          <th class="text-center extra-bold">Visit Priority</th>
          <th class="text-center extra-bold">Slope</th>
          <th class="text-center ps-2 extra-bold">TrendStatus</th>
          <th class="text-center extra-bold">Visit Required</th>
          <th class="text-center extra-bold">Action</th>
        </tr>
      </thead>

      <tbody>
        <tr @click="CreateCycle(site.siteCode)"
          v-for="site in paginatedSites"
          :key="site.siteCode"
          class="site-row"
        >

          <td class="text-center">
           {{ site.siteCode }}
             <br/>
            <small class="text-muted">
            </small>
          </td>

          <td class="text-center">
           {{ site.wri }}
             <br/>
            <small class="text-muted">
            </small>
          </td>

          <td class="text-center">
            <span :class="['badge', site.riskLevel.toLowerCase()]">
              {{ site.riskLevel }}
            </span>
          </td>

          <td class="text-center">
            {{ site.trend }}
          </td>

          <td class="text-center ps-2">
           {{ site.trendStatus }}
             <div>
               <!-- <strong>{{ site.pidType }}</strong> -->
             </div>
          </td>
          <td class="text-center">
            {{ site.visitRequired }}
          </td>
            <td class="text-center">
            <button  @click.stop.prevent="opencreateschdule(site.siteId, site.siteCode)"
            class="btn-sm ml-2 py-1 px-2"
              :class="site.action === 'Visit Now'
                ? 'btn-danger'
                : 'btn-primary'"
            >Shedule
            </button>
          </td>

        </tr>
      </tbody>
  </table>
  <div v-if="siteList.length != 0" class="row mt-1 mx-0">
  <div class="col-lg-12 mx-0 px-0">
    <div class="dataTables_paginate paging_simple_numbers pagination float-right">
      <div class="col-lg-12 d-flex justify-content-lg-end px-0">

        <v-pagination
          v-model="currentPageSite"
          :pages="siteTotalPage"
          :range-size="1"
           active-color="#618bd7"
          @update:modelValue="loadPageSite"
        />
      </div>
    </div>
  </div>
</div>

</div>

    </div>
    </div>
 </div>

      <div class="row mt-1">
        <div
          v-if="loading"
        class="d-flex flex-column align-items-center justify-content-center"
        style="position: absolute; inset: 0; background: rgba(255, 255, 255, 0.75); z-index: 2;"
        >
         <div class="spinner-border text-primary" role="status"></div>
          <div class="mt-2 text-muted">Loading data pls wait...</div>
        </div>
     <div class="col-lg-4 pr-1">
    <div class="site-card ">

   <div class="card-header priority-header">
       <p class="text-center align-items-center" >Site Visit Priority Breakdown</p>
   </div>

    <div class="d-flex align-items-center justify-content-between">

  <!-- YOUR EXISTING CHART -->
  <div class="chart-wrapper ms-2">
    <canvas ref="dummyDoughnutChart"></canvas>
  </div>

  <!-- RIGHT SIDE PRIORITY PANEL -->
  <div class="priority-panel mt-5">

    <div class="priority-item">
     <span class="priority-dot immediate"></span>
      <div>
     <strong>High</strong>
         {{ prioritySummary.High.count }} sites 
        ({{ prioritySummary.High.percent }}%)
      </div>
    </div>

    <hr>

    <div class="priority-item">
      <span class="priority-dot high"></span>
      <div>
        <strong>Medium</strong>
        {{ prioritySummary.Medium.count }} sites 
        ({{ prioritySummary.Medium.percent }}%)
      </div>
    </div>

    <hr>

    <div class="priority-item">
      <span class="priority-dot monitor"></span>
      <div>
        <strong>Low</strong>
       {{ prioritySummary.Low.count }} sites 
        ({{ prioritySummary.Low.percent }}%)
      </div>
    </div>

    <hr>

    <div class="priority-item">
      <span class="priority-dot stable"></span>
      <div>
         <div>
      <strong>Normal</strong>
    {{ prioritySummary.Normal.count }} sites 
      ({{ prioritySummary.Normal.percent }}%)
    </div>
      </div>
    </div>

  </div>

    </div>
    <!-- <p class="text-center pt-3">Distribution of sites by visit priority. Helps allocate CRA resources efficiently.</p> -->
    </div>
  </div>
  <div class="col-lg-4 pr-1"
    v-for="(kpi, index) in kpiList"
    :key="kpi.riskName || index">
  <div class="ibox mb-0">
    <div class="site-card mb-2">
      <!-- Header -->
      <div class="card-header  d-flex justify-content-between align-items-center">
       <div><i class="fa fa-info-circle"></i>
        <strong class="ms-1"><span>Upcoming Visit: </span><span class="text-danger">{{ kpi.visitName  || '-' }}</span></strong>
        </div>
        <span>
          <strong>{{ kpi.siteCode || '-' }}</strong>
        </span>
      </div>

      <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-1">
          <span style="font-size: 0.8rem;"><strong>Risk Level:</strong></span>
          <span
            class="risk-badge"
            :class="{
              'bg-danger': kpi.riskLevel === 'High',
              'bg-warning text-dark': kpi.riskLevel === 'Medium',
              'bg-success': kpi.riskLevel === 'Low',  
              'bg-primary': kpi.riskLevel === 'Normal'
            }"
            style="font-size: 0.6rem;"
          >
            {{ kpi.riskLevel || '-' }}
          </span>
        </div>
       <div class="mt-2">
         <!-- <p><strong>CraVisitType:</strong> {{ kpi.craVisitType }}</p> -->
         <!-- <p><strong>Monitoring Mode:</strong> {{ kpi.monitoringMode }}</p>
         <p><strong>Planned Date:</strong> <span class="text-danger">{{ formatDate(kpi.plannedDate) }}</span></p> -->
         <!-- <p><strong>Status:</strong> {{ kpi.status}} days</p> -->
          <!-- TOP METRICS -->
          <div class="metric-grid">

         <div class="metric-box">
             <div class="d-flex justify-content-between align-items-center ">
               <div class="metric-label">TrendStatus</div>
               <div class="metric-value">{{ kpi.trendStatus }}</div>
             </div>
         </div>

            <div class="metric-box">
              <div class="d-flex justify-content-between align-items-center ">
                <div class="metric-label">Trend Direction</div>
                <div class="metric-value">{{ kpi.trendDirection }}</div>
              </div>
            </div>

            <div class="metric-box">
              <div class="d-flex justify-content-between align-items-center ">
                <div class="metric-label">Attention Level</div>
    
                  <div class="metric-value"><span :style="{ color: kpi.requireattention ? 'green' : 'red' }">
               {{ kpi.requireattention ? 'true' : 'false' }}
            </span></div>
              </div>
            </div>
            <div class="metric-box">
              <div class="d-flex justify-content-between align-items-center">
                <div class="metric-label">Has Spike:</div>
                <div class="metric-value"><span :style="{ color: kpi.hasspike ? 'green' : 'red' }"> {{ kpi.hasspike  ? 'true' : 'false' }}</span></div>
              </div>
            </div>
          </div>
        <hr class="my-2">
        <!-- <p><strong>MaxScore:</strong>{{ kpi.maxzscore }}</p> -->
       <div class="kpi-info-grid">
          <p style="font-size: 11px;">Weighted ZScore: <strong style="font-size: 12px;">{{ kpi.weightedZScore }}</strong></p>
          <p class="text-end" style="font-size: 11px;">Visit Required:- <strong style="font-size: 12px;">{{ kpi.visittyperequiered }}</strong></p>
          <!-- <p style="font-size: 11px;">Visit Name:<strong class="text-danger" style="font-size: 12px;"> {{ kpi.visitName }}</strong></p> -->
          <p class="" style="font-size: 11px;">WRI:- <strong style="font-size: 12px;"> {{ kpi.wri }}</strong></p>
          <!-- <p><strong>WRI:</strong> {{ kpi.wri}}</p> -->
          <p class="text-end  me-3" style="font-size: 11px;">TrendSlope:- <strong style="font-size: 12px;"> {{ kpi.trendSlope}}</strong></p>
          <p  style="font-size: 11px;">TrendStrength:- <strong style="font-size: 12px;"> {{ kpi.trendStrength}}</strong></p>
          <p class="text-end me-4" style="font-size: 11px;">Volatility:- <strong style="font-size: 12px;"> {{ kpi.volatility}}</strong></p>
          <!-- <p><strong style="font-size: 12px;">Has Spike:</strong> <span :style="{ color: kpi.hasspike ? 'green' : 'red' }"> {{ kpi.hasspike  ? 'true' : 'false' }}</span></p> -->
          <p style="font-size: 11px;">Max ZScore:- <strong style="font-size: 12px;"> {{ kpi.maxzscore }}</strong></p>
          <!-- <p><strong>TrendDirection:</strong> {{ kpi.trendDirection}}</p> -->
    
              <p class="text-end me-4" style="font-size: 12px;">Avg Risk:- 
            <strong style="font-size: 12px;">{{ kpi.averageRiskScore}}</strong>
          </p>
          <!-- <p><strong>Average Risk Score:</strong> {{ kpi.averageRiskScore}}</p> -->
          <p style="font-size: 11px;">Peak Risk Score:- <strong style="font-size: 12px;"> {{ kpi.PeakRiskScore}}</strong></p>
          <p class="text-end me-4" style="font-size: 11px;">Data Points:- <strong style="font-size: 12px;"> {{ kpi.datapoints }}</strong></p>
          <!-- <p>
            <strong style="font-size: 12px;">Attention Level: </strong>
            <span :style="{ color: attentionColor(kpi.attentionLevel) }">
              {{ kpi.attentionLevel }}
            </span>
          </p> -->
           <!-- <p class="mt-1"><strong style="font-size: 12px;">Recommendation:</strong><span style="font-size: 12px;">{{ kpi.recommendation }}</span></p> -->
            <!-- <p class="" style="font-size: 11px;">WRI:- <strong style="font-size: 12px;"> {{ kpi.wri }}</strong></p> -->
       </div>
        <p><strong style="font-size: 12px;">Recommendation:- </strong><span class="text-success" style="font-size: 11px;">{{ kpi.recommendation }}</span></p>
         <!-- <p class="mt-1"><strong style="font-size: 12px;">Recommendation:</strong> {{ kpi.recommendation }}</p> -->
       </div>
        <!-- KPI Performance -->
      <!-- KPI Header with Toggle -->
<div 
  class="kpi-title cursor-pointer d-flex align-items-center"
  @click.stop="toggleKpiPerSite(kpi.siteCode)"
>
  <h5 class="section-title mt-1 text-primary fw-bold mb-0">
    KPI Performance
  </h5>

  <!-- Arrow Icon -->
  <i 
    class="fa mt-2 ms-2 text-primary" style="font-size: 12px"
    :class="isKpiExpanded(kpi.siteCode) ? 'fa-chevron-up' : 'fa-chevron-down'"
  ></i>
</div>

<!-- KPI Details -->
<div v-if="isKpiExpanded(kpi.siteCode)">
  <div v-for="(item, index) in kpi.kpis" :key="index" class="kpi-row mt-2">
    <p id="cardid"><strong style="font-size: 11px;">Weight:</strong>{{ item.weight }}</p>
    <div class="kpi-header d-flex justify-content-between align-items-center">
      {{ item.name }}
      <span :class="['badge', item.level.toLowerCase().replace(/\s+/g, '-')]">
        {{ item.score }} ({{ item.level }})
      </span>
    </div>

    <div class="progress">
      <div
        :class="['progress-fill', item.level.toLowerCase().replace(/\s+/g, '-')]"
        :style="getProgressStyle(item.score)"
      ></div>
    </div>
  </div>
</div>
<hr class="my-1">
        <!-- Question -->
     <div class="mt-3 d-flex justify-content-between align-items-center">
  <p class="fw-bold mb-0">Do you want to change mode?</p>
  
  <div class="d-flex gap-2">
    <!-- Yes Button - Rounded Outline -->
    <button  @click.stop.prevent="EditCRA(kpi.craVisitID)"
            class="btn btn-outline-success btn-sm rounded-pill px-4 fw-bold"
            style="border-radius: 50px !important;">
      Yes
    </button>
    
    <!-- No Button - Rounded Outline -->
    <button @click="closeCranewModal()" 
            class="btn btn-outline-danger btn-sm rounded-pill px-4 fw-bold"
            style="border-radius: 50px !important;">
      No
    </button>
  </div>
</div>
  </div>
    </div>
  </div>
</div>
  </div>
 <VisitPredictionDashboardModal
  v-if="showCreateCycleModal"
  :studyId="studyId"
  :siteCode="selectedSiteCode"
  @closeModal="closeCycleModal"
/>
<CreateSchedulePopup
  v-if="createschedulemodel"
  :siteId="siteId"
  :sitecode="siteCodeforpopup"
  @closescheduleModal="createschedulemodel = false"
/>
 <CraModal v-if="showCraModel" :editingId="craScheduleId" @closeModal="closeCraModal" @saved="refreshCraList" />

  <!-- <CraAddEditModal v-if="showCreateCraModal" :isEditMode="editingCraId !== null" :editingId="editingCraId"
  @closeModal="closeCranewModal" @saved="refreshCraList" /> -->
<CraAddEditModal 
  v-if="showCreateCraModal" 
  :editingId="editingCraId"
  :siteId="siteId"
  :siteCode="siteCodeforpopup"
  @closeModal="closeCranewModal" 
  @saved="refreshCraList" 
/>

</template>
<script src="./VisitPredictionDashboard.js"></script>

<style scoped>
@import "../../custom_lib/AiCharts/charts.css";

.site-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 2px 2px 5px rgba(226, 226, 226, 0.08);
  overflow: hidden;
  max-width: 380px;
  min-height: 380px;
  border: 1px solid #e3e1e1;

}

/* Header */
.card-header {
  padding: 8px 16px;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  
}

/* Body */
.card-body {
  padding: 10px;
}

.section-title {
  font-weight: 200;
  font-size:12px;
  margin-bottom: 4px;
}

.mt {
  margin-top: 20px;
}

/* KPI */
.kpi-row {
  margin-bottom: 2px;
}

.kpi-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  font-size: 12px;
}

.progress {
  height: 5px;
  background: #eee;
  border-radius: 10px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 10px;
}

.progress-fill.low { background: #198754; }
.progress-fill.medium { background: #ffc107; }
.progress-fill.high { background: #dc3545; }
.progress-fill.out-of-range { background: #52e226; }

.badge {
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.badge.low {
  background: #198754;
  color: white;
}

.badge.medium {
  background: #ffc107;
  color: black;
}

.badge.high {
  background: #dc3545;
  color: white;
}
.badge.out-of-range {
  background: #00405e;
  color: white;
}
/* Density */
.density {
  text-align: center;
}
.btn-sm {
  font-size: 10px;
  line-height:.8;
}
.muted {
  color: #6c757d;
  margin-bottom: 8px;
}

.formula {
  font-size: 13px;
  margin-bottom: 10px;
}

.risk-badge {
  background: #ffc107;
  padding: 6px 14px;
  border-radius: 6px;
  font-weight: 600;
}
.site-row:hover {
  background-color: #f9fafb;
  transition: 0.2s;
}

td {
  vertical-align: middle;
}
.danger-compact {
  padding: 3px 3px !important;
}
.badge.low {
  background: #198754;
  color: white;
  padding: 2px 8px;
}

.badge.medium {
  background: #ffc107;
  color: black;
  padding: 2px 8px;
}

.badge.immediate {
  background: #dc3545;
  color: white;
  padding: 2px 8px;
}
.badge{
  font-size: 9px;
}
.card-body p {
  margin-bottom: 5px;   /* reduce spacing */
}
.chart-card {
  height: 400px;
  border-radius: 12px;
}
.chart-wrapper {
  position: relative;
  height: 160px;   /* control chart height here */
  width: 100%;
}
.chart-wrapper {
  width: 200px;
  height: 188px;
  position: relative;
  margin-top: 15px;
}
.priority-panel {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 12px;
  width: 142px;
}

.priority-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.priority-item strong {
  display: block;
}

.priority-item p {
  margin: 0;
  font-size: 13px;
  color: #6c757d;
}

.priority-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.immediate { background: #ff6b6b; }
.high { background: #ffc857; }
.monitor { background: #4dabf7; }
.stable { background: #20c997; }

.priority-panel hr {
  margin: 14px 0;
}
.form-check-input {
  margin-top: 0.2rem;
}
.extra-bold {
  font-weight: 700;
}
.kpi-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 10px;
  font-size: 13px;
}
.metric-grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap:8px;
  margin-bottom:10px;
}

.metric-box{
  background:#f6f8fb;
  border-radius:10px;
  padding:0px 6px;
  border:1px solid #eef1f4;
  flex-wrap: nowrap;
}

.metric-label{
  font-size:11px;
  color:#6c757d;
}

.metric-value{
  font-weight:600;
  font-size:12px;
  white-space: nowrap;
}
.kpi-info-grid {
  display: grid;
  grid-template-columns: 178px 1fr;
  gap: 4px 12px;
  font-size: 13px;
  align-items: center;
}
.kpi-label {
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
}

.kpi-value {
  text-align: right;
  color: #212529;
  word-break: break-word;
}
.card-header p{
  margin: 0;
  font-size: 1px;
}
.priority-header p{
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.priority-header{
  display: flex;
  justify-content: center;   /* horizontal center */
  align-items: center;       /* vertical center */
  padding: 6px 10px;
}
#cardid{
  margin-bottom: 1px;
}
/* Base Badge Style */
.risk-badge {
  display: inline-block;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 50px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  color: #fff;
  transition: all 0.3s ease;
}

/* High Risk */
.risk-badge.high {
  background: linear-gradient(135deg, #ff4d4f, #b30000);
}

/* Medium Risk */
.risk-badge.medium {
  background: linear-gradient(135deg, #ffb84d, #ff8c00);
  color: #222;
}

/* Low Risk */
.risk-badge.low {
  background: linear-gradient(135deg, #2ecc71, #1e8449);
}

/* Normal Risk */
.risk-badge.normal {
  background: linear-gradient(135deg, #4da6ff, #0047b3);
}

/* Hover Glow Effect */
.risk-badge:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(0,0,0,0.25);
}
</style>
